module.exports = __webpack_public_path__ + "static/media/climatereality.ce923015.png";